import CandidateProfile from '../../candidateProfile/CandidateProfile';

const CustomerProfile = () => <CandidateProfile isForCostumerProfile={true} />;

export default CustomerProfile;
